import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { withTranslation } from 'react-i18next';

import TechSpecsItem from './TechSpecsItem';

import './TechSpecsUnitSwitchSection.module.css';

const UnitSwitchSection = DisplayComponent(
  class UnitSwitchSection extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        active: 0
      };
    }

    handleUnitSwitch = index => {
      this.setState({
        active: index
      });
    };

    render() {
      const { techSpecsItems, t, classes } = this.props;
      //t('Metric')
      //t('US')
      const measurementUnitTitle = techSpecsItems.map((techSpecsItem, i) => {
        return (
          <button
            key={techSpecsItem.measurementUnit}
            styleName={classNames(
              'measurement-unit',
              this.state.active === i
                ? 'measurement-unit-active'
                : 'measurement-unit-inactive'
            )}
            onClick={() => this.handleUnitSwitch(i)}
          >
            {t(techSpecsItem.measurementUnit)}
          </button>
        );
      });

      return (
        <div className={classes}>
          <div styleName="units">
            {t('Units')}
            {measurementUnitTitle}
          </div>
          <TechSpecsItem
            attributes={this.props.techSpecsItems[this.state.active]}
          />
        </div>
      );
    }
  }
);

UnitSwitchSection.propTypes = {
  title: PropTypes.string,
  techSpecsItems: PropTypes.array
};

export default withTranslation()(UnitSwitchSection);
